import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/Sort.svg?component
var Sort_exports = /* @__PURE__ */ __exportAll({
	default: () => Sort_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", {
		fill: "none",
		stroke: "currentColor",
		"stroke-linecap": "round",
		"stroke-linejoin": "round",
		d: "M2 5.4h20M2 12h20M2 18.6h13.3"
	}, null, -1)])]);
}
var Sort_default = { render: render$1 };
//#endregion
export { Sort_exports, Sort_default as default, render$1 as render };

//# sourceMappingURL=Sort.svg_component.js.map